




























































import {Component, Vue} from 'vue-property-decorator';
import SubscriptionPlanService from "@/services/SubscriptionPlanService";
import Workspaces from "@/state/Workspaces";
import SubscriptionService from "@/services/SubscriptionService";
import UserSubscriptionDetailsDTO from "@/dto/subscription/UserSubscriptionDetailsDTO";
import {processError} from "@/utils/ComponentUtils";
import PayPalPlanDTO from "@/dto/subscription/PayPalPlanDTO";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import ProfileService from "@/services/ProfileService";
import UserSummary from "@/dto/profile/UserSummary";
import SubscriptionsAdminModal from "@/components/profile/admin/SubscriptionsAdminModal.vue";
import AddProfilesAdminModal from "@/components/profile/admin/AddProfilesAdminModal.vue";
import {BillingAgreementStatus, SubscriberType} from "@/constants/SubscriptionConstants";
import Clipboard from "@/state/Clipboard";

@Component({
  components: { SubscriptionsAdminModal, AddProfilesAdminModal }
})
export default class SubscriptionsAdminView extends Vue {

  subscriptions: Array<UserSubscriptionDetailsDTO> = []
  planGroups: Array<{ group: PortalDictionaryDTO; plans: Array<PayPalPlanDTO> }> = []
  userSummary: UserSummary | null = null

  showCreateModal = false
  showAddProfilesModal = false
  selectedSubscription: UserSubscriptionDetailsDTO | null = null

  // expose enum to template
  public BillingAgreementStatus = BillingAgreementStatus

  copyApproveLink(link: string) {
    if (!link) return;
    Clipboard.write(link);
  }

  async mounted() {
    await this.loadSubscriptions();
    await this.loadPlans();
    await this.loadProfiles();
  }

  async loadSubscriptions() {
    this.$loadOn();
    await SubscriptionService.getUserSubscriptions(this.userId).then(
        ok => {
          this.subscriptions = ok.data
          this.$loadOff();
        },
        error => processError(this, error)
    )
  }

  async loadPlans() {
    this.$loadOn();
    try {
      const groups = (await SubscriptionPlanService.getUserActivePayPalGroups(this.userId)).data
      this.planGroups = await Promise.all(
          groups.map(async (g) => {
            const plans = (await SubscriptionPlanService.getActivePayPalPlans(g.name)).data
            return {group: g, plans}
          })
      )
    } catch (e) {
      processError(this, e)
    }
    this.$loadOff();
  }

  async loadProfiles() {
    try {
      const resp = await ProfileService.getUserSummary(this.userId)
      this.userSummary = resp.data
    } catch (e) {
      processError(this, e)
    }
  }

  async onModalCreated(link: string) {
    // refresh subscriptions and keep modal open to show link inside it; close after refresh
    await this.loadSubscriptions()
    this.showCreateModal = true // keep open; parent just acknowledges
  }

  hasAddableProfiles(s: UserSubscriptionDetailsDTO): boolean {
    if (!this.userSummary) return false;

    // Проверка доступности персоны
    const canAddPerson = (s.subscriberType === SubscriberType.PERSON || s.subscriberType === SubscriberType.ALL) &&
      this.userSummary.person &&
      (!s.person || s.person.id !== this.userSummary.person.id);

    // Проверка доступности компаний
    const currentCompanyIds = new Set(s.companies.map(c => c.id));
    const hasNewCompanies = (s.subscriberType === SubscriberType.COMPANY || s.subscriberType === SubscriberType.ALL) &&
      this.userSummary.companies.some(c => !currentCompanyIds.has(c.id));

    return !!(canAddPerson || hasNewCompanies);
  }

  openAddProfilesModal(s: UserSubscriptionDetailsDTO) {
    this.selectedSubscription = s;
    this.showAddProfilesModal = true;
  }

  async onProfilesAdded(link: string) {
    await this.loadSubscriptions();
    // Модалка остается открытой для копирования ссылки
  }

  get userId(): number {
    return Workspaces.getCurrent.userId;
  }
}
